





























































import Vue from 'vue'
import style from './style.module.scss'

import textInput from '@/components/controls/text-input/text-input.vue'

import textInput2 from './input.vue'
import selectSimple from '@/components/controls/select/select-simple.vue'
import unitSelector from '../unit-selector/unit-selector.vue'
import numeric from 'vue-numeric-input'

import { ProductCharacteristic, ProductCharacteristicTypes } from '@/types/supplier-search'

import { UnitsModel } from '@/types/common'

const typesList = [
    { id: ProductCharacteristicTypes.String, value: 'Текст'},
    { id: ProductCharacteristicTypes.Integer, value: 'Число'},
    { id: ProductCharacteristicTypes.Decimal, value: 'Число с плавающей точкой'},
]

export default Vue.extend({
    name: 'characteristics-list',
    components: {
        textInput,
        textInput2,
        selectSimple,
        unitSelector,
        numeric
    },
    data() {
        return {
            style: style,
            ProductCharacteristicTypes: ProductCharacteristicTypes,
            typeList: typesList
        }
    },
    methods: {
        getItemUnit(item: ProductCharacteristic): UnitsModel {
            return {
                UnitName: item.UnitName || '',
                UnitCode: item.UnitCode || '',
                UnitShortName: item.UnitShortName || ''
            }
        },
        focusName(item: ProductCharacteristic) {
            item.NameFocused = true;
            if(!item.ShowTypeSelector) {
                item.ShowTypeSelector = true;
            }
        },
        nameBlured(item: ProductCharacteristic) {
            item.NameFocused = false;
            setTimeout(() => {
                if(!item.TypeSelectorFocused) {
                    item.ShowTypeSelector = false;
                }
            }, 10)
        },
        typeSelectorFocus(item: ProductCharacteristic) {
            item.TypeSelectorFocused = true;
        },
        typeSelectorBlur(item: ProductCharacteristic) {
            setTimeout(() => {
                if(!item.NameFocused) {
                    item.ShowTypeSelector = false;   
                }
                item.TypeSelectorFocused = false;
            }, 100);
        },
        selectType(value: ProductCharacteristicTypes, item: ProductCharacteristic) {
            item.Value.Type = value
        },
        unitSelectorToggle(item: ProductCharacteristic, isOpen: boolean) {
            item.UnitSelectorOpen = isOpen;
        },
        deleteItem(index?: number) {
            this.$store.dispatch('deleteCharacteristic', index);
        },
        addItemHandler(): void {
            this.$store.dispatch('addCharacteristic');
        },
        selectUnit(data: UnitsModel, item: ProductCharacteristic) {
            item.UnitCode = data.Code?.toString();
            item.UnitName = data.Name?.toString();
            item.UnitShortName = data.ShortName?.toString();
        }
    },
    computed: {
        characteristicsForDisplay(): ProductCharacteristic[] {
            return this.$store.getters.characteristicsForDisplay || [];
        }
    }
})
